// src/screens/tabs/Menu/MenuScreen.tsx
import React, { useEffect, useState } from "react";
import { View, ScrollView, Text } from "react-native";
import { useNavigation } from "@react-navigation/native";
import { menuScreenStyles as styles } from "../styles/styles";
import { FlickOColors } from "../styles/color";
import {
  MenuItemType,
  OrganizedMenu,
  RestaurantMenu,
} from "../types/restaurant.types";
import { organizeMenu } from "../services/menu.service";
import LoadingSpinnerTrans from "../LoadingSpinner";
import { calculateRestaurantRating, Ratings } from "../component/RatingInfo";
import { CategoryCard } from "./menu/CategoryCard";
import { RestaurantProfile } from "./menu/RestaurantProfile";
import { QuickFilters } from "../component/QuickFilters";
import { FilterDropdown } from "../component/FilterDropdown";
import { MenuFilterState, MenuInitialFilterState } from "./menu/FilterTypes";
import {
  filterAndSortMenuItems,
  organizeFilteredMenu,
} from "./menu/FilterUtils";
import { RegiSteps } from "../component/RegistrationSteps";
import { NavigationProps } from "../../../types/navigation";
import { SearchBar } from "../component/SearchBar";

interface MenuScreenProps {
  restData: RestaurantMenu | null;
  loading: boolean;
  onEditPress: () => void;
  headerComponent?: React.ReactNode;
  onAddToCart: (item: MenuItemType, quantity: number) => void;
}

const MenuScreen = ({
  headerComponent,
  restData,
  loading,
  onEditPress,
  onAddToCart,
}: MenuScreenProps) => {
  const navigation = useNavigation<NavigationProps>();
  const [searchQuery, setSearchQuery] = useState("");
  const [organizedMenu, setOrganizedMenu] = useState<OrganizedMenu>({});
  const [ratings, setRatings] = useState<Ratings>({
    avgReview: 0,
    totalReview: 0,
  });
  const [filters, setFilters] = useState<MenuFilterState>(
    MenuInitialFilterState
  );
  const [filteredMenu, setFilteredMenu] = useState<OrganizedMenu>({});
  const [originalItems, setOriginalItems] = useState<MenuItemType[]>([]);

  const handleFiltersChange = (newFilters: MenuFilterState) => {
    setFilters(newFilters);
    const filteredItems = filterAndSortMenuItems(originalItems, newFilters);
    setFilteredMenu(organizeFilteredMenu(filteredItems));
  };

  useEffect(() => {
    if (restData) {
      setOriginalItems(restData.menuItems ?? []);
      const organized = organizeMenu(restData.menuItems ?? []);
      console.log("organized: ", organized);
      setOrganizedMenu(organized);
      const rating = calculateRestaurantRating(restData.menuItems ?? []);
      console.log("rating: ", rating);
      setRatings(rating);
      setFilteredMenu(organized);
    }
  }, [restData]);

  if (loading || !restData) return <LoadingSpinnerTrans />;

  return (
    <View style={styles.container}>
      {headerComponent}
      <ScrollView>
        <RestaurantProfile
          restData={restData}
          ratings={ratings}
          onEditPress={onEditPress}
        />

        <SearchBar
          value={searchQuery}
          onChangeText={setSearchQuery}
          placeholder="Search menu"
          iconColor={FlickOColors.text.secondary}
        />

        <ScrollView
          horizontal
          showsHorizontalScrollIndicator={false}
          style={styles.filtersScrollView}
          contentContainerStyle={styles.filtersContentContainer}
        >
          <FilterDropdown
            filters={filters}
            onApplyFilters={handleFiltersChange}
            onClearFilters={() => {
              setFilters(MenuInitialFilterState);
              setFilteredMenu(organizedMenu);
            }}
          />
          <QuickFilters
            selectedTypes={filters.foodType}
            onToggleType={(type) => {
              const newTypes = filters.foodType.includes(type)
                ? filters.foodType.filter((t) => t !== type)
                : [...filters.foodType, type];
              handleFiltersChange({ ...filters, foodType: newTypes });
            }}
            onMoreFilters={() => {}}
          />
        </ScrollView>

        <View>
          {Object.values(organizedMenu).map((category) => (
            <CategoryCard
              onAddToCart={onAddToCart}
              key={category.name}
              category={category}
            />
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

export default MenuScreen;
